<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="字符编码" prop="i18nCode">
      <a-input v-model="form.data.i18nCode"/>
    </a-form-model-item>
    <a-form-model-item
      :key="language.code"
      v-for="language in language.data"
      :label="language.name">
      <a-input v-model="language.value"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" @click="onUpdate">{{ $t('UPDATE') || '更新' }}</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryLanguages,
} from '@/api/sys/languageApi';
import {
  _queryI18NDetail,
  _updateI18NDetail,
} from '@/api/sys/i18NDetailApi';

async function getI18NDetail() {
  if (this.i18nCode) {
    const result = await _queryI18NDetail(this.i18nCode);
    const map = new Map();
    result.forEach(x => map.set(x.languageCode, x.value));
    this.language.data = this.language.data.map(x => ({
      ...x,
      value: map.get(x.code),
    }));
  }
}


async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const detail = this.language.data.map(x => ({
        languageCode: x.code,
        i18nCode: this.i18nCode,
        value: x.value,
      }));
      await _updateI18NDetail(this.form.data.i18nCode, detail);
      if (this.onSubmitHandler) {
        this.$message.success(this.$t('UPDATE_SUCCESS'));
        if (this.onSubmitHandler) {
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'I18NDetailEdit',
  props: {
    i18nCode: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  methods: {
    onUpdate,
    onCancel,
    getI18NDetail,
  },
  data() {
    return {
      head: {},
      form: {
        data: {
          i18nCode: this.i18nCode,
        },
        rules: {
          i18nCode: [{ required: true, trigger: 'blur' }],
        },
      },
      language: {
        data: [],
      },
    };
  },
  async created() {
    const languageResult = await _queryLanguages({});
    this.language.data = languageResult.content.filter(y => y.isActive !== 'NO')
      .map(x => ({
        ...x,
        value: '',
      }));
    this.getI18NDetail();
  },
};
</script>
